module.exports = __webpack_public_path__ + "assets/img/570c43a2b883bb060bc82f9d40132605.png";